import { render, staticRenderFns } from "./EducationBlock.vue?vue&type=template&id=3cc33436"
import script from "./EducationBlock.vue?vue&type=script&lang=js"
export * from "./EducationBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports